exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".panel-trabajo-turnos .table>tbody>tr>td{padding:10px;border-top-width:1px;border-top-style:solid;line-height:1.42857143;vertical-align:top;font-weight:400}.panel-trabajo-turnos .table tbody tr td{color:inherit;border-left:none}.panel-trabajo-turnos .table tbody tr td:last-child{color:inherit;border-right:none}.panel-trabajo-turnos .table tbody tr:first-child td:last-child{border-top-right-radius:0}.panel-trabajo-turnos .table tbody tr:first-child td:first-child{border-top-left-radius:0}.progressbar-small .progress-label,.progressbar-small .progress-overlay,.progressbar-small.progressbar,.progressbar-small .progressbar-value{height:10px}.panel-trabajo-turnos .progress-cell{width:40%}.panel-trabajo-turnos .progress-cell .progressbar{margin-top:5px}.panel-trabajo-turnos .panel-content{border-radius:4px}.page-content-full{background:#fafcfe;rgin-left:260px;padding:20px 30px}.page-content-full>.container{padding:0;max-width:100%}body{background:#fafcfe}.badge-no-concretable{margin-left:6px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/tablero-turnos/tablero.scss
// module id = 902
// module chunks = 0